import clsx from 'clsx';

export const singleItemBadgeClasses = clsx(
  'inline-flex',
  'items-center',
  'gap-x-1.5',
  'whitespace-nowrap',
  'rounded-xl',
  'bg-gray-100',
  'px-3',
  'py-1',
  'text-xs',
  'font-medium',
  'cursor-pointer',
  'hover:bg-gray-200',
  'transition-colors',
  'text-blue-600',
  'max-w-8',
  'sm:max-w-8',
  'md:max-w-12',
  'lg:max-w-[3.2rem]',
  'xl:max-w-24',
  '2xl:max-w-40',
);

export const countBadgeClasses = clsx(
  'inline-flex',
  'items-center',
  'gap-x-1.5',
  'whitespace-nowrap',
  'rounded-xl',
  'bg-gray-100',
  'px-3',
  'py-1',
  'text-xs',
  'font-medium',
  'cursor-pointer',
  'hover:bg-gray-200',
  'transition-colors',
  'text-blue-600',
);
